import React, { useState, useEffect } from 'react';
import { noop } from 'lodash';
import { func, bool, string } from 'prop-types';
import classNames from 'classnames';

const Image = ({
    isActive = false,
    src,
    placeholderSrc,
    alt = '',
    onDimensions = noop,
    lazyLoad = false,
    onLoad = noop,
    onClick = noop,
}) => {
    const [hasBeenRequested, setHasBeenRequested] = useState(isActive || !lazyLoad);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setHasBeenRequested(isActive || !lazyLoad);
    }, [isActive, lazyLoad, src]);

    const handleLoad = (e) => {
        if (e?.target) {
            const { naturalWidth: width, naturalHeight: height } = e.target;
            onLoad(e);
            onDimensions({ width, height });
            setIsLoaded(true);
        }
    };

    const classes = classNames({ 'image-loaded': isLoaded });

    const placeholder = placeholderSrc ? (
        <img onClick={onClick} alt={alt} src={placeholderSrc} onLoad={handleLoad} className={classes} />
    ) : null;

    return hasBeenRequested ? (
        <img onClick={onClick} alt={alt} src={src} onLoad={handleLoad} className={classes} />
    ) : (
        placeholder
    );
};

Image.propTypes = {
    isActive: bool.isRequired,
    src: string.isRequired,
    placeholderSrc: string,
    alt: string,
    onDimensions: func,
    lazyLoad: bool,
    onLoad: func,
    onClick: func,
};

export default Image;
